export default "__VITE_ASSET__Bh$KETBc__"